import styles from './ItineraryMapMarker.module.scss'
import { ExtendedItineraryItem, ItineraryMapMarker as ItineraryMapMarkerInterface } from '@/interfaces'
import { InfoWindow, Marker } from '@react-google-maps/api'
import React, { useContext } from 'react'
import { useTranslation } from 'next-i18next'
import { AppConfigContext } from '@/app/providers/AppConfigProvider'

interface Props {
  marker: ItineraryMapMarkerInterface
  extendedItineraryItem: ExtendedItineraryItem
  index: number
  isOpen: boolean
  openInfoWindow: () => void
  closeInfoWindow: () => void
  onLoad?: (marker: google.maps.Marker) => void
}
// eslint-disable-next-line react/display-name
const ItineraryMapMarker = React.forwardRef(
  ({ marker, extendedItineraryItem: item, index, isOpen, openInfoWindow, closeInfoWindow, onLoad = () => {} }: Props, ref) => {
    const appConfig = useContext(AppConfigContext)
    const { t } = useTranslation('common')
    return (
      <Marker
        position={marker.position}
        label={{ text: (index + 1).toString(), color: '#fff', className: 'map-marker-label' }}
        icon={appConfig.googleMap.marker.icon ?? null}
        key={index}
        onLoad={onLoad}
        onClick={openInfoWindow}
        // @ts-ignore
        ref={ref}
        data-tr-click="travel_page:itinerary_map_marker:click"
      >
        {isOpen && (
          <InfoWindow onCloseClick={closeInfoWindow}>
            <div className={styles.root}>
              <div className={styles.dateInfo}>
                {t('travel.itinerary.day')} {item.dayString} | {item.dateString}
              </div>
              <div className={styles.content}>{item.title}</div>
            </div>
          </InfoWindow>
        )}
      </Marker>
    )
  }
)

export default ItineraryMapMarker
